import { usePromptGroups } from './usePromptGroups';
import { useSelector } from 'react-redux';
import {
  selectPromptGroups,
  selectPromptGroupsWithPrompts_deprecated,
} from '../../../reducers/promptLibraryReducer';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';
import { useFeatureToggle } from '../../../feature-flags/useFeatureToggle';

const useInitializePromptGroups = () => {
  const { loadPromptGroups, loadPromptGroups_deprecated } = usePromptGroups();
  const { promptsLibraryV2 } = useFeatureToggle();

  // Select appropriate state based on feature flag
  const promptGroupsV2 = useSelector(selectPromptGroups);
  const promptGroupsV1 = useSelector(selectPromptGroupsWithPrompts_deprecated);

  const shouldLoadV2 = promptsLibraryV2 && !promptGroupsV2;
  const shouldLoadV1 = !promptsLibraryV2 && !promptGroupsV1;

  useRunOnceWhenTruthy(() => {
    loadPromptGroups();
  }, shouldLoadV2);

  useRunOnceWhenTruthy(() => {
    loadPromptGroups_deprecated();
  }, shouldLoadV1);
};
export default useInitializePromptGroups;
